import {
  Router,
  ReactLocation,
  useSearch,
  Outlet,
} from "@tanstack/react-location";
import { lazy, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { esimQuery } from "../utils/query";
import { queryClient } from "../utils/query-client";
import HomePage from "./home";
import type { MakeGenerics } from "@tanstack/react-location";

const PurchaseSuccessPage = lazy(() => import("./purchase-success"));
const PurchaseFailPage = lazy(() => import("./purchase-fail"));
const TermsOfServicePage = lazy(() => import("./terms-of-service"));

export type LocationGenerics = MakeGenerics<{
  Search: {
    locale: string;
    currency: string;
    countryCode: string;
    dataPlan: string;
  };
}>;

const location = new ReactLocation<LocationGenerics>();

const Root = () => {
  const { i18n } = useTranslation();
  const { locale } = useSearch<LocationGenerics>();

  useEffect(() => {
    if (locale) {
      i18n.changeLanguage(locale);
    }
  }, [i18n, locale]);

  return <Outlet />;
};

const Routing = () => {
  return (
    <Router
      location={location}
      routes={[
        {
          element: <Root />,
          children: [
            {
              path: "/",
              element: <HomePage />,
              loader: async () => ({
                countries:
                  queryClient.getQueryData(["countries"]) ??
                  queryClient
                    .fetchQuery(["countries"], () =>
                      esimQuery.getEsimCountries(),
                    )
                    .then(() => ({})),
              }),
            },
            {
              path: "purchase-success",
              element: <PurchaseSuccessPage />,
            },
            {
              path: "purchase-fail",
              element: <PurchaseFailPage />,
            },
            {
              path: "terms-of-service",
              element: <TermsOfServicePage />,
            },
            {
              element: <>404</>,
            },
          ],
        },
      ]}
      basepath="esim"
    />
  );
};

export default Routing;
